<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="年度" name="fiscalYearMonth">
                <YearPicker style="width: 100%" v-model:value="searchForm.fiscalYearMonth" :format="dateFormat.DATE_YEAR"
          :showTime="false" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #fiscalYearMonth="{record}">
                <a @click="onDetail(record)">{{record.fiscalYearMonth}}</a>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import Detail from "./components/Detail";
import {tableListMixin} from "@/mixins";
import {financeCompanyInfo} from "@/api/finance";
import YearPicker from "@/components/form/datePicker/YearPicker";
import {dateFormat} from "@/config/variableConfig";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "年份", dataIndex: "fiscalYearMonth", key: "fiscalYearMonth", slots: {customRender: "fiscalYearMonth"}},
    {title: "总资产(万元)", dataIndex: "totalAssets", key: "totalAssets"},
    {title: "公司名称", dataIndex: "companyName", key: "companyName", width:'200px'},
    {title: "总负债(万元)", dataIndex: "totalLiability", key: "totalLiability"},
    {title: "营业收入(万元)", dataIndex: "operatingIncome", key: "operatingIncome"},
    {title: "净利润(万元)", dataIndex: "retainedProfits", key: "retainedProfits"},
    // {title: "缴税总额", dataIndex: "totalTax", key: "totalTax"},
    {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "信息补充",
    mixins: [tableListMixin],
    components: {
        AddOrEditModal,
        Detail,
        YearPicker
    },
    data() {
        return {
            dateFormat,
            dictNames: 'isPublic,serviceStatus,condition,demand_type',
            columns,
            queryParam: {},
            listUrl: financeCompanyInfo.pageList,
            listKeyField: "id",
            deleteUrl: financeCompanyInfo.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeCompanyInfo.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
        onDetail(record){
            this.getAction({
                url: financeCompanyInfo.detail,
                params: {id: record.id}
            }).then(res=>{
                this.onShowModal("detailmodal", res)
            })
        }
    }
}
</script>

<style scoped>

</style>
